import { convertValueToBaseUnit } from "views/components/visualizations/utils/unitConverters";
const convertDataToBaseUnit = (values, unit) => {
  if (!(unit == null ? void 0 : unit.isDefined)) return values;
  const from = { abbrev: unit.abbrev, unitType: unit.unitType };
  return values.map((v) => {
    const converted = convertValueToBaseUnit(v, from);
    return converted.value;
  });
};
export default convertDataToBaseUnit;
